import { render } from "./NotFound.vue?vue&type=template&id=1d860e4f"
const script = {}
script.render = render

export default script